"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadGoodsPromotionTemplate = downloadGoodsPromotionTemplate;
exports.importGoodsPromotion = importGoodsPromotion;
exports.queryGoodsPromotionDetail = queryGoodsPromotionDetail;
exports.queryGoodsPromotionPage = queryGoodsPromotionPage;
exports.saveOrUpdateGoodsPromotion = saveOrUpdateGoodsPromotion;
exports.updEnable = updEnable;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityGoodsPromote';

// 获取商品促销分页列表
function queryGoodsPromotionPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取商品促销详情
function queryGoodsPromotionDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 添加与编辑商品促销
function saveOrUpdateGoodsPromotion(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}
// 添加与编辑商品促销
function updEnable(data) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/updEnable',
    method: 'get',
    params: data
  });
}

// 导入商品促销
function importGoodsPromotion(formData) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 下载商品促销导入模板
function downloadGoodsPromotionTemplate() {
  return (0, _requestPIM.default)({
    url: querestUrl + '/downloadTemplate',
    method: 'get',
    responseType: 'blob'
  });
}